import React from 'react'

export default function TravelerIcon({ className, size = 48 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="32" cy="32" r="30" fill="url(#traveler-bg)" opacity="0.2" />
      <defs>
        <linearGradient id="traveler-bg" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#667eea" />
          <stop offset="100%" stopColor="#764ba2" />
        </linearGradient>
        <linearGradient id="traveler-main" x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="#4facfe" />
          <stop offset="100%" stopColor="#00f2fe" />
        </linearGradient>
      </defs>
      
      {/* Рюкзак */}
      <rect
        x="22"
        y="20"
        width="20"
        height="26"
        rx="3"
        fill="url(#traveler-main)"
        opacity="0.9"
      />
      
      {/* Верхняя часть рюкзака */}
      <rect
        x="26"
        y="16"
        width="12"
        height="6"
        rx="2"
        fill="url(#traveler-main)"
        opacity="0.7"
      />
      
      {/* Лямки */}
      <path
        d="M26 22 Q20 28 20 36"
        stroke="url(#traveler-main)"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M38 22 Q44 28 44 36"
        stroke="url(#traveler-main)"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      
      {/* Карман на рюкзаке */}
      <rect
        x="26"
        y="28"
        width="12"
        height="10"
        rx="2"
        fill="#1a1a2e"
        opacity="0.3"
      />
      
      {/* Застежка */}
      <circle cx="32" cy="33" r="2" fill="#667eea" />
      
      {/* Компас (на кармане) */}
      <circle cx="32" cy="24" r="3" stroke="url(#traveler-main)" strokeWidth="1.5" fill="none" />
      <path d="M32 21 L32 27" stroke="url(#traveler-main)" strokeWidth="1" />
      
      {/* Декоративные полоски */}
      <line x1="24" y1="42" x2="40" y2="42" stroke="#1a1a2e" strokeWidth="1" opacity="0.3" />
    </svg>
  )
}
